import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addHomeGroupAdminFailure,
  //
  addHomeGroupAdminSuccess,
  deleteHomeGroupAdminFailure,
  //
  deleteHomeGroupAdminSuccess,
  editHomeGroupAdminFailure,
  //
  editHomeGroupAdminSuccess,
  fetchHomeGroupAdmins as fetchHomeGroupAdminsAction,
  fetchHomeGroupAdminsFailure,
  fetchHomeGroupAdminsSuccess,
  getViewDataFailure,
  getViewDataSuccess,
  //
  inviteAdmin,
  inviteAdminFailure,
  inviteAdminSuccess,
  //
  getUserListSuccess,
  getUserListFailure,
} from "./actions";
import {
  ADD_HOME_GROUP_ADMIN,
  DELETE_HOME_GROUP_ADMIN,
  EDIT_HOME_GROUP_ADMIN,
  FETCH_HOME_GROUP_ADMINS,
  GET_VIEW_DATA,
  INVITE_ADMIN,
  GET_USER_LIST,
} from "./constants";

export function* fetchHomeGroupAdminsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/company-admin?${query}`);
    yield put(fetchHomeGroupAdminsSuccess(data));
  } catch (e) {
    yield put(fetchHomeGroupAdminsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching admins!"));
  }
}

export function* getViewDataSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/company-admin/${payload}`
    );
    yield put(getViewDataSuccess(data));
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addHomeSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const userInfo = yield select((state) => state?.AuthReducer?.user);
  try {
    const data = yield call(
      api(token).post,
      `/api/company-admin/add`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Admin added successfully!"));
      yield put(addHomeGroupAdminSuccess());
      yield put(
        fetchHomeGroupAdminsAction({
          page: 1,
          limit: 10,
          company_id: payload.data.company_id,
          user_id: userInfo?.id,
        })
      );
      yield put(inviteAdmin(payload?.data));
    }
  } catch (e) {
    yield put(addHomeGroupAdminFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* inviteAdminSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const userInfo = yield select((state) => state?.AuthReducer?.user);

  try {
    const data = yield call(
      api(token).post,
      `/api/company-admin-invite`,
      payload.data
    );
    if (data) {
      yield put(inviteAdminSuccess());
      yield put(
        fetchHomeGroupAdminsAction({
          page: 1,
          limit: 10,
          company_id: payload.data.company_id,
          user_id: userInfo?.id,
        })
      );
    }
  } catch (e) {
    yield put(inviteAdminFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editAdminSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const userInfo = yield select((state) => state?.AuthReducer?.user);

  try {
    const data = yield call(
      api(token).post,
      `/api/company-admin/edit/${payload.data.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Admin updated successfully!"));
      yield put(editHomeGroupAdminSuccess());
      yield put(
        fetchHomeGroupAdminsAction({
          page: 1,
          limit: 10,
          company_id: payload.data.company_id,
          user_id: userInfo?.id,
        })
      );
    }
  } catch (e) {
    yield put(editHomeGroupAdminFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteAdminSaga({ payload, onDeleteSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const user = yield select((state) => state?.AuthReducer?.user);
  try {
    const data = yield call(
      api(token).delete,
      `/api/company-admin/${payload?.id}`
    );
    if (data) {
      yield put(successAlert("Admin deleted successfully!"));
      yield put(deleteHomeGroupAdminSuccess());
      typeof onDeleteSuccess === "function" && onDeleteSuccess();
    }
  } catch (e) {
    yield put(deleteHomeGroupAdminFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getUserListSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/admin-staff-list?${query}`
    );
    yield put(getUserListSuccess(data));
  } catch (e) {
    yield put(getUserListFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* fetchHomeGroupAdminsFlow() {
  yield takeEvery(FETCH_HOME_GROUP_ADMINS, fetchHomeGroupAdminsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addHomeFlow() {
  yield takeEvery(ADD_HOME_GROUP_ADMIN, addHomeSaga);
}
export function* editHomeFlow() {
  yield takeEvery(EDIT_HOME_GROUP_ADMIN, editAdminSaga);
}
export function* deleteHomeFlow() {
  yield takeEvery(DELETE_HOME_GROUP_ADMIN, deleteAdminSaga);
}
export function* inviteAdminFlow() {
  yield takeEvery(INVITE_ADMIN, inviteAdminSaga);
}
export function* getUserListFlow() {
  yield takeEvery(GET_USER_LIST, getUserListSaga);
}

export default function* HomeGroupsAdminSaga() {
  yield all([
    fetchHomeGroupAdminsFlow(),
    addHomeFlow(),
    editHomeFlow(),
    deleteHomeFlow(),
    getViewDataFlow(),
    inviteAdminFlow(),
    getUserListFlow(),
  ]);
}
